exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social-status-label[data-v-aa9e5f70]{padding:10px 0;color:var(--wf-secondary);font-weight:600;cursor:pointer}", ""]);

// exports
